module.exports = __webpack_public_path__ + "media/Video (7).a9a195ee.mp4";